/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Kno2Document
 */
export interface Kno2Document {
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    document_origin?: Kno2DocumentDocumentOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    document_type: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    confidentiality?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    document_name: string;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    s3_key: string;
    /**
     * 
     * @type {number}
     * @memberof Kno2Document
     */
    document_size?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    author?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Kno2Document
     */
    organization_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Document
     */
    document_created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Document
     */
    service_period_start?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Document
     */
    service_period_end?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Kno2Document
     */
    is_processed?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof Kno2Document
     */
    created_at: Date;
}


/**
 * @export
 */
export const Kno2DocumentDocumentOriginEnum = {
    Tefca: 'tefca',
    Carequality: 'carequality'
} as const;
export type Kno2DocumentDocumentOriginEnum = typeof Kno2DocumentDocumentOriginEnum[keyof typeof Kno2DocumentDocumentOriginEnum];


/**
 * Check if a given object implements the Kno2Document interface.
 */
export function instanceOfKno2Document(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "document_type" in value;
    isInstance = isInstance && "document_name" in value;
    isInstance = isInstance && "s3_key" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function Kno2DocumentFromJSON(json: any): Kno2Document {
    return Kno2DocumentFromJSONTyped(json, false);
}

export function Kno2DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Kno2Document {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'document_origin': !exists(json, 'document_origin') ? undefined : json['document_origin'],
        'document_type': json['document_type'],
        'confidentiality': !exists(json, 'confidentiality') ? undefined : json['confidentiality'],
        'document_name': json['document_name'],
        's3_key': json['s3_key'],
        'document_size': !exists(json, 'document_size') ? undefined : json['document_size'],
        'author': !exists(json, 'author') ? undefined : json['author'],
        'organization_name': !exists(json, 'organization_name') ? undefined : json['organization_name'],
        'document_created_date': !exists(json, 'document_created_date') ? undefined : (json['document_created_date'] === null ? null : new Date(json['document_created_date'])),
        'service_period_start': !exists(json, 'service_period_start') ? undefined : (json['service_period_start'] === null ? null : new Date(json['service_period_start'])),
        'service_period_end': !exists(json, 'service_period_end') ? undefined : (json['service_period_end'] === null ? null : new Date(json['service_period_end'])),
        'is_processed': !exists(json, 'is_processed') ? undefined : json['is_processed'],
        'created_at': (new Date(json['created_at'])),
    };
}

export function Kno2DocumentToJSON(value?: Kno2Document | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'document_origin': value.document_origin,
        'document_type': value.document_type,
        'confidentiality': value.confidentiality,
        'document_name': value.document_name,
        's3_key': value.s3_key,
        'document_size': value.document_size,
        'author': value.author,
        'organization_name': value.organization_name,
        'document_created_date': value.document_created_date === undefined ? undefined : (value.document_created_date === null ? null : value.document_created_date.toISOString()),
        'service_period_start': value.service_period_start === undefined ? undefined : (value.service_period_start === null ? null : value.service_period_start.toISOString().substring(0,10)),
        'service_period_end': value.service_period_end === undefined ? undefined : (value.service_period_end === null ? null : value.service_period_end.toISOString().substring(0,10)),
        'is_processed': value.is_processed,
        'created_at': (value.created_at.toISOString()),
    };
}

